import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { IDataItem, TableSmall } from '../../../../../components/Dashboard/TableSmall'
import { data } from './BalancesTableList'
import { balancesSelector } from '../../../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 40,
    maxHeight: 40,
    paddingBottom: theme.spacing(2),
  },
  section: {
    justifyContent: 'space-between',
    padding: theme.spacing(1, 3, 1, 3),
    background: theme.palette.background.paper,
  },
}))

export const Balances: FC = () => {
  const classes = useStyles()
  const { status, data: balancesData } = useSelector(balancesSelector)

  return (
    <Grid item xs={12} className={classes.wrap}>
      <Grid item xs={12} className={classes.container}>
        <Typography variant={'h6'}>Balances</Typography>
      </Grid>
      <Grid container item xs={12} className={classes.section}>
        <TableSmall
          loading={status === 'LOADING'}
          columns={data.columns}
          data={balancesData as unknown as IDataItem[]}
          pb={16}
          paginationMT={16}
          params={{
            currentPage: 1,
            itemsPerPage: 10,
            itemCount: 0,
            totalItems: 0,
            totalPages: 0,
          }}
        />
      </Grid>
    </Grid>
  )
}
